import ReviewDisplay from './ReviewDisplay';

export default ReviewDisplay;
